import type { FC } from 'react';
import { Navigate, useLocation, useParams } from 'react-router';
import {
  SECURITY_CLIENTS_HREF,
  SECURITY_ENDPOINTS_HREF,
} from 'src/mindtime/config/securityNav';
import { SECURITY_PAGE_FILTER_KEYS } from 'src/mindtime/constants/securityFilters';
import Endpoints from '../endpoints/Endpoints';

type ClientDetailsLocationState = {
  clientName?: string;
};

/** Clients child route: Endpoints UI locked to the selected client organization. */
const ClientDetails: FC = () => {
  const { clientId: encodedClientId = '' } = useParams<{ clientId: string }>();
  const location = useLocation();
  const clientId = decodeURIComponent(encodedClientId).trim();
  const clientName =
    (location.state as ClientDetailsLocationState | null)?.clientName?.trim() || clientId;

  if (!clientId) {
    return <Navigate to={SECURITY_CLIENTS_HREF} replace />;
  }

  return (
    <Endpoints
      forcedOrganizationId={clientId}
      pageTitle={clientName}
      filterPageKey={SECURITY_PAGE_FILTER_KEYS.clientEndpoints}
      breadcrumb={{
        links: [
          { name: 'EDR', to: SECURITY_ENDPOINTS_HREF },
          { name: 'Clients', to: SECURITY_CLIENTS_HREF },
          { name: clientName, to: '' },
        ],
      }}
    />
  );
};

export default ClientDetails;
